module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-7-bf4ffd897000ff6f74849304d748da8f.png";